import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { OpenAnswer } from '@shared/models/question-types/open-answer';
import { NumberOfBytesPipe } from '@shared/pipes/number-of-bytes.pipe';
import { ValidatorComponent } from '../../../validator/validator.component';

@Component({
  selector: 'app-open-answer-validation',
  imports: [ValidatorComponent, CommonModule, NumberOfBytesPipe],
  templateUrl: './open-answer-validation.component.html',
  styleUrl: './open-answer-validation.component.scss',
})
export class OpenAnswerValidationComponent {
  @Input({ required: true }) question!: OpenAnswer;
  @Input() control?: any;
  ValidatorType = ValidatorType;
}
